import { Action, combineReducers } from '@ngrx/store';
import * as fromBusinesses from './businesses.reducer';
import * as fromCreateBusiness from './create-business.reducer';

export const businessesFeatureKey = 'businesses';

export interface BusinessesState {
  [fromBusinesses.businessesFeatureKey]: fromBusinesses.BusinessListState;
  [fromCreateBusiness.createBusinessFeatureKey]: fromCreateBusiness.CreateBusinessState;
}

export interface State {
  [businessesFeatureKey]: BusinessesState;
}

export function reducers(state: BusinessesState | undefined, action: Action) {
  return combineReducers({
    [fromBusinesses.businessesFeatureKey]: fromBusinesses.reducer,
    [fromCreateBusiness.createBusinessFeatureKey]: fromCreateBusiness.reducer
  })(state, action);
}
